import { useState } from 'react';
import {
  Button,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { SubPage } from '../../../../../contexts/PagesContext';

const LocalButtonComponent = ({
  open,
  handleClick,
  subpage,
}: {
  open: boolean,
  handleClick: (e: React.MouseEvent<HTMLButtonElement>) => void,
  subpage: SubPage
}) => (
  !subpage.is_subpage_published ? (
    <span>
      <Button
        type="button"
        className="btn btn-outline-secondary dropdown-toggle"
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        disabled={subpage.is_subpage_published}
      >
        操作を選択
      </Button>
    </span>
  ) : (
    <Tooltip
      title="公開状態で操作することができません "
    // placement="right"
    >
      <span>
        <Button
          type="button"
          className="btn btn-outline-secondary dropdown-toggle"
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          disabled={subpage.is_subpage_published}
        >
          操作を選択
        </Button>
      </span>
    </Tooltip>
  )
);

interface props {
  index: number,
  subpage: SubPage,
  mainPageDomain: string,
  openEditModal: () => void,
  openDeleteModal: () => void,
  setSelectedSubPage: (subpage: SubPage) => void,
}

function SubPageItem({
  index,
  subpage,
  mainPageDomain,
  openEditModal,
  openDeleteModal,
  setSelectedSubPage,
}: props) {
  // variables
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // functions
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <tr>
        <td className="text-center">{index}</td>
        <td className="text-center">{subpage.is_subpage_published ? '公開' : '非公開'}</td>
        <td>
          <div>
            {subpage.subpage_title}
          </div>
          <div className="text-sm">
            https://
            {mainPageDomain}
            /
            <span className="bg-secondary-subtle p-1 me-1 fw-normal">
              <span className="text-success">
                {subpage.url_path}
              </span>
            </span>
            /
          </div>
        </td>
        <td className="table-action text-center">
          <div className="btn-group btn-group-sm">
            <LocalButtonComponent
              open={open}
              handleClick={handleClick}
              subpage={subpage}
            />
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClick={handleClose}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={() => { setSelectedSubPage(subpage); openEditModal(); }} style={{ color: '#212529' }}>
                <ListItemIcon>
                  <FontAwesomeIcon color="#212529" icon={faEdit} fontSize="small" />
                </ListItemIcon>
                編集
              </MenuItem>
              <MenuItem onClick={() => { setSelectedSubPage(subpage); openDeleteModal(); }} className="text-danger">
                <ListItemIcon>
                  <FontAwesomeIcon className="text-danger" icon={faTrashCan} fontSize="small" />
                </ListItemIcon>
                削除
              </MenuItem>
            </Menu>
          </div>
        </td>
      </tr>
    </>
  );
}

export default SubPageItem;
